<template>
  <div class="compressed-content">
    <h3 class="page-question">
      Do you currently smoke or have you ever been a smoker (1/2 pack of cigarettes or more per day)?<br />
      Do you use smokeless tobacco?
    </h3>

    <v-form-group class="card-selector page-buttons" :validator="$v.patientSmokingStatus">
      <b-form-radio v-model="survey.smoking.smokingStatus" name="smoking" :value=smokingStatus.NotSmoking>
        No
      </b-form-radio>
      <b-form-radio v-model="survey.smoking.smokingStatus" name="smoking" :value=smokingStatus.SmokingCurrently>
        Current
      </b-form-radio>
      <b-form-radio v-model="survey.smoking.smokingStatus" name="smoking" :value=smokingStatus.SmokedInPast>
        Past
      </b-form-radio>
      <b-form-checkbox v-model="survey.smoking.isSmokeless">
        Smokeless
      </b-form-checkbox>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import smokingStatus from 'enums/smoking-status';

  export default {
    mixins: [formMixin],

    data() {
      return {
        smokingStatus: smokingStatus
      };
    },

    validations: {
      patientSmokingStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      patientSmokingStatus() { return this.survey.smoking.smokingStatus; }
    }
  };
</script>